<h1 class="sr-only"><span>VENTA MESES SIN INTERESES SORTEO ANÁHUAC MAGNO 2026</span></h1>

<section class="stc-msi banner-padding">
    <div class="container">
        <div class="row sub-headers-inside">

            <div class="col-12 text-center my-auto">
                <div class="overlap-signature header-inside">

                    <span class="letter"> <span class="signature-text">Meses</span></span>
                    <h2 class="main-text">sin intereses</h2>
                </div>
            </div>


        </div>
    </div>
</section>


<section class="container-msi">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <p>
                    Compra ahora y paga tus boletos a meses sin intereses. Esta promoción es exclusiva para tarjetas
                    participantes y en compras directas en la <strong>máquina de la suerte</strong> de nuestra página
                    web.
                </p>


                <a href="{{ urlMicrositio }}/compra-en-linea-boletos-sorteo-anahuac{{utmUrl}}" target="_blank"
                    class="btn-stack">
                    ¡Compra aquí a
                    meses sin intereses!
                </a>


                <p>
                    Vigencia de la promoción del 01 de abril al 19 de noviembre 2026.
                </p>
            </div>
        </div>
    </div>
</section>


<section class="stc-cards">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12 text-center">
                <h4>¡conoce los bancos participantes!</h4>
                <img src="/assets/images/sorteo2023/santander-msi.png" class="img-fluid" alt="Santander">

                <img src="/assets/images/sorteo2023/banorte.png" class="img-fluid" alt="Banorte">

                <img src="/assets/images/sorteo2023/scotiabank-msi.png" class="img-fluid" alt="Scotiabank">
                <img src="/assets/images/sorteo2023/hsbc.png" class="img-fluid" alt="HSBC">
                <img src="/assets/images/sorteo2023/banjercito.png" class="img-fluid" alt="Banjercito">
                <img src="/assets/images/sorteo2023/liverpool.png" class="img-fluid" alt="Liverpool">
                <img src="/assets/images/sorteo2023/banco-azteca.png" class="img-fluid" alt="Banco Azteca">


            </div>
        </div>
    </div>
</section>


<section class="stc-time">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <h2>
                    ¡meses sin intereses!
                </h2>
            </div>

            <div class="col-lg-3 col-md-6 text-center">
                <img src="/assets/images/sorteo2026/meses1.png" class="img-fluid" alt="MSI">

            </div>

            <div class="col-lg-3 col-md-6 text-center">
                <img src="/assets/images/sorteo2026/meses2.png" class="img-fluid" alt="MSI">

            </div>

            <div class="col-lg-3 col-md-6 text-center">
                <img src="/assets/images/sorteo2026/meses3.png" class="img-fluid" alt="MSI">

            </div>

            <div class="col-lg-3 col-md-6 text-center">
                <img src="/assets/images/sorteo2026/meses4.png" class="img-fluid" alt="MSI">

            </div>

        </div>
    </div>
</section>


<section class="msi-privacidad">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <h3> TÉRMINOS Y CONDICIONES DE USO DE LOS MESES SIN INTERESES.</h3>
                <ul>
                    <li>
                        Únicamente boletos comprados en máquina de la suerte.
                    </li>
                    <li>
                        Compras a través de la App de Sorteo Anáhuac y boletos físicos no participan en este promoción.
                    </li>
                    <li>
                        CAT 0% Informativo.
                    </li>
                    <li>
                        Consulta bancos participantes antes de finalizar tu pago.
                    </li>
                    <li>
                        Reclamaciones: Cualquier reclamación por no aplicar bien los meses sin intereses deberá ser
                        reportada al banco emisor de la tarjeta.
                        Promoción está sujeta a cambio sin previo aviso.
                    </li>
                </ul>
                <h3>
                    INFORMACIÓN RELEVANTE
                </h3>
                <p>
                    Es requisito necesario para la adquisición de los Boletos del Sorteo Anáhuac, que lea y acepte los
                    siguientes Términos y Condiciones que a continuación se redactan.
                </p>
                <p>
                    La compra de los Boletos implicará que usted ha leído y aceptado los Términos y Condiciones de Uso
                    en el presente documento.
                    Todas las compras de los Boletos que se lleven a cabo por medio del sitio web están sujetas a un
                    proceso de confirmación y verificación, el cual se realiza de forma inmediata.
                    Los precios de los Boletos y los meses sin intereses ofrecidos son válidos solamente en las compras
                    realizadas en el sitio web
                </p>
                <h3>
                    AVISO DE PRIVACIDAD
                </h3>
                <p>
                    Este sitio web, garantiza que la información personal que usted envía cuenta con la seguridad
                    necesaria. Para más información consulte: <a href="{{urlWeb}}/aviso-de-privacidad" target="_blank"
                        style="color: #fc5705;">https://www.sorteoanahuac.mx/aviso-de-privacidad</a>
                </p>
            </div>
        </div>
    </div>
</section>